export default __webpack_public_path__ + "static/media/apostar_icons_eingabe_1_allgdaten.bcd10b34.svg";